module.exports = __webpack_public_path__ + "img/Forestier_22_FM_recadrer.def09a4a.jpg";